/* =====================================================================
   Desert City Games — Advanced Search (Arsenal) bundled scripts
   File: assets/dcg-advanced-search.js

   This is the combined version of the inline <script> blocks that lived
   in sections/advanced_search.liquid. Loaded with defer BEFORE
   advancedSearch.js — defer preserves source order, so the four patches
   below install global hooks before the BinderPOS engine runs.

   Sections, in order:
     1. Patch — querySelector override (BinderPOS hardcoded section id)
     2. Patch — localStorage intercept (prevent game lock on first load,
                normalize availabilty, exclude games, default game keyword)
     3. Patch — fetch override (strip aborted signals, sanitize forStore
                request body, capture variant.quantity into _dcgBinderQtyMap)
     4. Patch — insertBefore shim (redirect mobile filter panel injection
                to the sidebar element so the drawer is populated)
     5. Hero search bar + filter pills + sidebar style patcher + custom
        set search widget + sort restriction for limited games
     6. BinderPOS card reshaper + Shopify enrichment + auto-advance for
        sold-out price-sort pages
     7. Mobile filter drawer (open/close + active count badge)

   Each section is its own IIFE; cross-section state shared via:
     window._dcgIsExcluded         (set in §2, read in §5)
     window._dcgPreferGameKeyword  (set in §2, read in §5)
     window._dcgBinderQtyMap       (set in §3, read in §6)
===================================================================== */

/* ── §1: querySelector override ───────────────────────────────────── */
(function () {
  var _qs  = document.querySelector.bind(document);
  var _qsa = document.querySelectorAll.bind(document);
  var NEEDLE = '#shopify-section-advanced_search';

  function getSection() {
    return _qs('#shopify-section-advanced_search')
        || _qs('.shopify-section.section-advanced-search')
        || (function () {
             var all = _qsa('[id^="shopify-section-"]');
             for (var i = 0; i < all.length; i++) {
               if (all[i].querySelector('.dcg-as-wrap')) return all[i];
             }
             return null;
           })();
  }

  function patch(sel) {
    if (typeof sel !== 'string' || sel.indexOf(NEEDLE) === -1) return null;
    var s = getSection();
    if (!s || !s.id) return null;
    return sel.replace(NEEDLE, '#' + s.id);
  }

  document.querySelector = function (sel) {
    var r = _qs(sel); if (r) return r;
    var p = patch(sel); return p ? _qs(p) : null;
  };

  document.querySelectorAll = function (sel) {
    var r = _qsa(sel); if (r.length) return r;
    var p = patch(sel); return p ? _qsa(p) : r;
  };
})();


/* ── §2: localStorage intercept — prevent game lock ──────────────── */
(function () {
  /* If a ?game= param was passed from the header search autocomplete, honour it.
     Otherwise fall back to 'magic' as the store default.
     Set to '' to disable automatic game selection entirely. */
  var urlGameParam = new URLSearchParams(window.location.search).get('game') || '';
  /* '' = All Categories (store default); populated from ?game= param set by autocomplete */
  var PREFERRED_GAME = urlGameParam || 'magic';

  /* Games that should never appear in the UI or be auto-selected */
  var EXCLUDED_GAMES = ['sealed pokemon', 'sealed pokémon'];
  function isExcluded(txt) {
    var t = (txt || '').toLowerCase();
    return EXCLUDED_GAMES.some(function (x) { return t.indexOf(x) !== -1; });
  }
  /* Expose for use in later script blocks */
  window._dcgIsExcluded = isExcluded;

  /* Clear stale localStorage if the user previously had an excluded game saved */
  try {
    var _stale = JSON.parse(localStorage.getItem('advancedSearch') || 'null');
    if (_stale && _stale.game && isExcluded(String(_stale.game))) {
      delete _stale.game;
      delete _stale._dcgUserPick;
      localStorage.setItem('advancedSearch', JSON.stringify(_stale));
    }
  } catch(e) {}

  /* Default availability to All Singles for new visitors */
  try {
    var _initData = JSON.parse(localStorage.getItem('advancedSearch') || 'null');
    if (!_initData) {
      localStorage.setItem('advancedSearch', JSON.stringify({
        availabilty: 'false', order: 'title-ascending'
      }));
    } else if (_initData.availabilty === false) {
      _initData.availabilty = 'false';
      localStorage.setItem('advancedSearch', JSON.stringify(_initData));
    }
  } catch(e) {}

  var _setItem = localStorage.setItem.bind(localStorage);
  localStorage.setItem = function (key, value) {
    if (key === 'advancedSearch') {
      try {
        var data = JSON.parse(value);
        if (data && data.availabilty === false) {
          data.availabilty = 'false';
          value = JSON.stringify(data);
        }
        var existing = null;
        try { existing = JSON.parse(localStorage.getItem('advancedSearch') || 'null'); } catch(e) {}
        var userHasPick = existing && existing._dcgUserPick;
        if (data && data.game && !userHasPick) {
          if (PREFERRED_GAME) {
            window._dcgPreferGameKeyword = PREFERRED_GAME;
          } else {
            delete data.game;
            value = JSON.stringify(data);
          }
        }
      } catch(e) {}
    }
    return _setItem(key, value);
  };
})();


/* ── §3: fetch override — fix aborted signals + variants:null 500 ── */
(function () {
  var _fetch = window.fetch.bind(window);
  window.fetch = function (url, opts) {
    if (!opts) return _fetch(url);

    var patched = {};
    for (var k in opts) patched[k] = opts[k];

    /* Strip permanently-aborted signals so retries always go through */
    if (patched.signal && patched.signal.aborted) {
      delete patched.signal;
    }

    /* Fix variants:null → variants:[] on the products/forStore POST.
       buildVariantsOptions() returns null when no condition/printing is
       selected. BinderPOS server returns HTTP 500 on null — it needs [].
       Also sanitize sortTypes — 'relevance' is not a valid BinderPOS sort
       type and causes 500. Map it to 'title' ascending. */
    if (
      typeof url === 'string' &&
      url.indexOf('products/forStore') !== -1 &&
      patched.body
    ) {
      try {
        var body = JSON.parse(patched.body);
        /* Fix 1: variants null */
        if (body.variants === null || body.variants === undefined) {
          body.variants = [];
        }
        /* Fix 2: invalid sortType */
        var validSortTypes = ['price', 'title', 'name', 'number'];
        if (body.sortTypes && body.sortTypes.length) {
          body.sortTypes = body.sortTypes.map(function (st) {
            if (validSortTypes.indexOf(st.type) === -1) {
              return { type: 'title', asc: true, order: st.order || 1 };
            }
            return st;
          });
        }
        patched.body = JSON.stringify(body);
      } catch (e) {}
    }

    var result = _fetch(url, patched);

    /* Intercept products/forStore response — extract variant.quantity
       from the BinderPOS API payload and store in window._dcgBinderQtyMap
       keyed by shopifyId. We consume and reconstruct the response so
       _dcgBinderQtyMap is guaranteed populated before BinderPOS's .then()
       runs and renders cards — eliminating the timing race. */
    if (typeof url === 'string' && url.indexOf('products/forStore') !== -1) {
      return result.then(function (response) {
        var status  = response.status;
        var headers = response.headers;
        return response.json().then(function (data) {
          /* Populate qty map from the parsed response */
          window._dcgBinderQtyMap = window._dcgBinderQtyMap || {};
          if (data && data.products) {
            data.products.forEach(function (product) {
              if (!product.variants) return;
              product.variants.forEach(function (variant) {
                window._dcgBinderQtyMap[String(variant.shopifyId)] =
                  typeof variant.quantity === 'number' ? variant.quantity : 0;
              });
            });
          }
          /* Return a reconstructed Response so BinderPOS can still read the data */
          return new Response(JSON.stringify(data), { status: status, headers: headers });
        }).catch(function () { return new Response('{}', { status: status }); });
      });
    }

    return result;
  };
})();


/* ── §4: insertBefore shim — redirect mobile filter to sidebar ───── */
(function () {
  var _orig = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, refNode) {
    if (
      newNode &&
      newNode.classList &&
      newNode.classList.contains('left-column') &&
      newNode.classList.contains('tag-filter')
    ) {
      var sidebar = document.querySelector('[data-section-id="sidebar"]');
      if (sidebar) { sidebar.prepend(newNode); return newNode; }
    }
    return _orig.call(this, newNode, refNode);
  };
})();


/* ── §5: Hero search bar + filter pills + sidebar style patcher ──── */
(function () {
  'use strict';

  var sbar      = document.getElementById('dcg-as-sbar');
  var heroInput = document.getElementById('dcg-as-hero-q');
  var clearBtn  = document.getElementById('dcg-as-clear');
  var submitBtn = document.getElementById('dcg-as-submit');
  var pillsEl   = document.getElementById('dcg-as-pills');
  var urlQ      = new URLSearchParams(window.location.search).get('q');
  var urlDecoded = urlQ ? decodeURIComponent(urlQ) : '';

  /* Clear any cached sort order that would cause BinderPOS to send
     sortTypes:[{type:'relevance'}] — 'relevance' is not a valid BinderPOS
     sort type and causes a 500. Reset localStorage so #SortBy default wins. */
  (function () {
    try {
      var saved = JSON.parse(localStorage.getItem('advancedSearch') || '{}');
      var validOrders = ['title-ascending','title-descending','price-ascending','price-descending','name-ascending','name-descending'];
      if (saved && saved.order && validOrders.indexOf(saved.order) === -1) {
        saved.order = 'title-ascending';
        localStorage.setItem('advancedSearch', JSON.stringify(saved));
      }
    } catch (e) {}
  })();

  /* Pre-fill hero bar immediately */
  if (urlDecoded && heroInput) heroInput.value = urlDecoded;

  /* BinderPOS's own sidebar input#q (created async) */
  function getBinderInput() {
    return document.querySelector('.filters-toolbar__input input#q');
  }

  /* Mirror hero → BinderPOS input.
     Writes the hero value into BinderPOS's own #q input and drives its search.
     Hardened against three failure modes that left the typed name unapplied:
       1. Event coverage — fire keydown + input + keyup so BinderPOS captures
          the value and schedules its debounced search whichever handler it uses.
       2. Async render — BinderPOS builds input#q after this script runs; retry
          briefly (capped) so an early submit isn't silently dropped.
       3. One-cycle-behind — BinderPOS's debounceSearch starts the fetch and only
          then reads input#q into this.query, so a single trigger can fetch with a
          stale/empty term. On explicit search we re-assert once after the debounce
          window so a corrected fetch (with the real term) always follows. */
  var mirrorTimer;

  /* Keep BinderPOS's #q search field in sync with the hero box.
     BinderPOS wipes #q whenever it re-renders its filters (notably on a game
     change), which dropped the searched name and reverted results to everything.
     After every BinderPOS render cycle, if #q is empty while the hero still holds
     a term, restore it and re-run the search.
     Gated on #q being EMPTY, which:
       - never fights the user while they type or after they clear the search, and
       - is loop-safe: once restored, #q is non-empty so this no-ops until the
         next wipe (the restore fires a plain search, not a game change, so
         BinderPOS doesn't rebuild/clear #q again). */
  function enforceHeroQuery() {
    if (!heroInput) return;
    var hv = heroInput.value.trim();
    if (!hv) return;                 /* no active term — nothing to hold */
    var b = getBinderInput();
    if (!b) return;                  /* #q not present yet */
    if (b.value) return;             /* already populated — user typing or in sync */
    pushBinderQuery(hv);             /* #q was wiped by a re-render — restore + search */
  }

  function pushBinderQuery(val) {
    var b = getBinderInput();
    if (!b) return false;
    b.value = val;
    b.dispatchEvent(new Event('keydown', { bubbles: true }));
    b.dispatchEvent(new Event('input',   { bubbles: true }));
    b.dispatchEvent(new Event('keyup',   { bubbles: true }));
    return true;
  }

  function mirrorToBinderPOS(immediate) {
    if (!heroInput) return;
    var val = heroInput.value;

    if (immediate) {
      /* Retry until BinderPOS's input#q exists (capped ~3s), then re-assert
         once past the debounce window to defeat the one-cycle-behind ordering. */
      var tries = 0;
      (function attempt() {
        if (pushBinderQuery(val)) {
          setTimeout(function () { pushBinderQuery(heroInput.value); }, 400);
        } else if (tries++ < 40) {
          setTimeout(attempt, 75);
        }
      })();
    } else {
      clearTimeout(mirrorTimer);
      mirrorTimer = setTimeout(function () { pushBinderQuery(val); }, 50);
    }
  }

  function syncClear() {
    if (sbar && heroInput) sbar.classList.toggle('has-value', heroInput.value.length > 0);
  }

  syncClear();

  if (heroInput) {
    heroInput.addEventListener('input', function () { syncClear(); mirrorToBinderPOS(false); });
  }

  if (clearBtn && heroInput) {
    clearBtn.addEventListener('click', function () {
      heroInput.value = ''; heroInput.focus(); syncClear(); mirrorToBinderPOS(true);
    });
  }

  if (submitBtn && heroInput) {
    submitBtn.addEventListener('click', function () { mirrorToBinderPOS(true); });
    heroInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); mirrorToBinderPOS(true); }
    });
  }

  /* ── Filter pills ───────────────────────────────────────────── */
  var pillsTimer;

  function getState() {
    var state = [];
    var gameEl = document.querySelector('.filters-toolbar__input select#game');
    if (gameEl && gameEl.selectedIndex > 0) {
      var opt = gameEl.options[gameEl.selectedIndex];
      if (opt) state.push({ key: 'game', label: 'Game', val: opt.text.trim().replace(/\s*Singles?\s*/i, '').trim() });
    }
    var condEl = document.querySelector('.filters-toolbar__input select#condition');
    if (condEl) {
      var vals = [];
      for (var i = 0; i < condEl.options.length; i++) {
        if (condEl.options[i].selected) vals.push(condEl.options[i].text.trim());
      }
      if (vals.length) state.push({ key: 'condition', label: 'Condition', val: vals.join(', ') });
    }
    var avEl = document.querySelector('.filters-toolbar__input select#availabilty');
    if (avEl && String(avEl.value) === 'true') {
      state.push({ key: 'availabilty', label: null, val: 'In stock only' });
    }
    var minEl = document.querySelector('input#priceMin');
    var maxEl = document.querySelector('input#priceMax');
    var minV  = minEl ? minEl.value.trim() : '';
    var maxV  = maxEl ? maxEl.value.trim() : '';
    if (minV || maxV) {
      state.push({ key: 'price', label: 'Price', val: (minV ? '$' + minV : '') + (minV && maxV ? ' – ' : '') + (maxV ? '$' + maxV : '') });
    }
    var setEl = document.querySelector('.filters-toolbar__input select#setNames');
    if (setEl) {
      var setVals = [];
      for (var j = 0; j < setEl.options.length; j++) {
        if (setEl.options[j].selected) setVals.push(setEl.options[j].text.trim());
      }
      if (setVals.length) state.push({ key: 'setNames', label: 'Set', val: setVals.join(', ') });
    }
    var printEl = document.querySelector('.filters-toolbar__input select#printing');
    if (printEl) {
      var printVals = [];
      for (var k = 0; k < printEl.options.length; k++) {
        if (printEl.options[k].selected) printVals.push(printEl.options[k].text.trim());
      }
      if (printVals.length) state.push({ key: 'printing', label: 'Printing', val: printVals.join(', ') });
    }
    var rarEl = document.querySelector('.filters-toolbar__input select#rarities');
    if (rarEl) {
      var rarVals = [];
      for (var l = 0; l < rarEl.options.length; l++) {
        if (rarEl.options[l].selected) rarVals.push(rarEl.options[l].text.trim());
      }
      if (rarVals.length) state.push({ key: 'rarities', label: 'Rarity', val: rarVals.join(', ') });
    }
    return state;
  }

  function clearFilter(key) {
    if (key === 'condition') {
      var el = document.querySelector('.filters-toolbar__input select#condition');
      if (!el) return;
      for (var i = 0; i < el.options.length; i++) el.options[i].selected = false;
      if (window.jQuery) window.jQuery(el).trigger('change'); else el.dispatchEvent(new Event('change'));
    } else if (key === 'availabilty') {
      var el = document.querySelector('.filters-toolbar__input select#availabilty');
      if (el) { el.value = 'false'; el.dispatchEvent(new Event('change')); }
    } else if (key === 'price') {
      ['input#priceMin', 'input#priceMax'].forEach(function (s) {
        var el = document.querySelector(s);
        if (el) { el.value = ''; el.dispatchEvent(new Event('keyup')); }
      });
    } else if (key === 'setNames' || key === 'printing' || key === 'rarities') {
      var el = document.querySelector('.filters-toolbar__input select#' + key);
      if (!el) return;
      for (var i = 0; i < el.options.length; i++) el.options[i].selected = false;
      if (window.jQuery) window.jQuery(el).val(null).trigger('change');
      else el.dispatchEvent(new Event('change'));
      /* Notify custom components directly — jQuery trigger doesn't reliably
         fire native addEventListener handlers when BinderPOS stops propagation */
      el.dispatchEvent(new CustomEvent('dcg:cleared', { bubbles: false }));
    }
    setTimeout(renderPills, 350);
  }

  function renderPills() {
    if (!pillsEl) return;
    var state = getState();
    pillsEl.innerHTML = '';
    state.forEach(function (f) {
      var pill = document.createElement('span');
      pill.className = 'dcg-as-pill';
      pill.setAttribute('role', 'listitem');
      pill.innerHTML =
        (f.label ? '<span class="dcg-as-pill__cat">' + f.label + '</span>' : '') +
        '<span class="dcg-as-pill__val">' + f.val + '</span>' +
        '<button type="button" class="dcg-as-pill__rm" aria-label="Remove ' + (f.label || f.val) + ' filter">' +
          '<svg viewBox="0 0 9 9" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" width="8" height="8">' +
          '<path d="M1 1l7 7M8 1L1 8"/></svg></button>';
      pill.querySelector('.dcg-as-pill__rm').addEventListener('click', function () { clearFilter(f.key); });
      pillsEl.appendChild(pill);
    });
    if (state.length > 1) {
      var cb = document.createElement('button');
      cb.type = 'button'; cb.className = 'dcg-as-pills__clear-all'; cb.textContent = 'Clear all';
      cb.addEventListener('click', function () {
        ['condition', 'availabilty', 'price', 'setNames', 'printing', 'rarities'].forEach(clearFilter);
        setTimeout(renderPills, 400);
      });
      pillsEl.appendChild(cb);
    }
  }

  function watchFilters() {
    document.querySelectorAll('.filters-toolbar__input select, .filters-toolbar__input input').forEach(function (el) {
      if (el.dataset.dcgW) return;
      el.dataset.dcgW = '1';
      el.addEventListener('change', function () { clearTimeout(pillsTimer); pillsTimer = setTimeout(renderPills, 300); });
      el.addEventListener('keyup',  function () { clearTimeout(pillsTimer); pillsTimer = setTimeout(renderPills, 600); });
    });
  }

  /* Poll until BinderPOS has injected filters */
  /* ── Patch BinderPOS inline styles on sidebar elements ───────────
     BinderPOS stamps inline styles (light border, no bg specified)
     on every input/select it creates. We override with setProperty
     (the only way to beat inline styles from JS).
     Also re-inits Select2 on any multi-select that missed first init.
  ────────────────────────────────────────────────────────────────── */
  function patchSidebarStyles() {
    if (!window.jQuery) { setTimeout(patchSidebarStyles, 50); return; }
    var $ = window.jQuery;

    /* Fix 0: Force ALL sidebar surfaces to #161820 — BinderPOS may set inline
       background styles that beat CSS !important. JS setProperty is the only override. */
    [
      '.filters-toolbar__input',
      '.left-column.tag-filter',
      '.left-inner',
      '#filter-container'
    ].forEach(function(sel) {
      var el = document.querySelector(sel);
      if (el) {
        el.style.setProperty('background', '#161820', 'important');
        el.style.setProperty('background-color', '#161820', 'important');
      }
    });

    /* Fix 1: BinderPOS label inline margin-bottom:20px and color:#27302f */
    document.querySelectorAll('.filters-toolbar__input label').forEach(function (lbl) {
      if (lbl.dataset.dcgPatched) return;
      lbl.dataset.dcgPatched = '1';
      lbl.style.setProperty('margin-bottom', '5px',                     'important');
      lbl.style.setProperty('margin-top',    '12px',                    'important');
      lbl.style.setProperty('color',         'rgba(255,255,255,0.75)',  'important');
      lbl.style.setProperty('font-size',     '10px',                    'important');
      lbl.style.setProperty('font-weight',   '600',                     'important');
      lbl.style.setProperty('font-family',   'Poppins,sans-serif',      'important');
      lbl.style.setProperty('text-transform','uppercase',               'important');
      lbl.style.setProperty('letter-spacing','0.08em',                  'important');
      lbl.style.setProperty('display',       'block',                   'important');
      lbl.style.setProperty('padding',       '0',                       'important');
      lbl.style.setProperty('border',        'none',                    'important');
      lbl.style.setProperty('background',    'transparent',             'important');
    });

    /* Fix 2: Remove empty grid div BinderPOS appends after Condition */
    document.querySelectorAll('.filters-toolbar__input > div[style*="grid"]').forEach(function (div) {
      if (div.children.length === 0) {
        div.style.setProperty('display', 'none',  'important');
        div.style.setProperty('height',  '0',     'important');
        div.style.setProperty('margin',  '0',     'important');
        div.style.setProperty('padding', '0',     'important');
      }
    });

    /* Fix 3: Take full ownership of Select2 on every sidebar multi-select.
       BinderPOS calls .select2() with no placeholder option, creating an
       empty selection box. It may also double-init. We destroy everything
       and reinit once with the correct data-placeholder attribute.
       Tracked by data-dcg-s2-init to only run once per select. */
    document.querySelectorAll('.filters-toolbar__input select[multiple]').forEach(function (sel) {
      if (sel.dataset.dcgS2Init) return;
      sel.dataset.dcgS2Init = '1';

      var ph = sel.getAttribute('data-placeholder') || 'Browse…';

      /* Step 1: Destroy any existing Select2 instance cleanly */
      try { $(sel).select2('destroy'); } catch(e) {}

      /* Step 2: Remove ALL orphaned .select2-container elements near this select.
         Select2 appends its container as a sibling after the select inside the label.
         Walk up to parent and remove every .select2-container we find. */
      var parent = sel.parentNode;
      if (parent) {
        parent.querySelectorAll('.select2-container').forEach(function (c) {
          try { c.parentNode.removeChild(c); } catch(e) {}
        });
      }

      /* Step 3: Ensure the native select is visible so Select2 can measure it */
      sel.style.removeProperty('display');
      sel.classList.remove('select2-hidden-accessible');

      /* Step 4: Fresh init with correct placeholder + substring search matcher */
      $(sel).select2({
        placeholder: ph,
        allowClear: false,
        width: '100%',
        dropdownAutoWidth: false,
        matcher: function (params, data) {
          if (!params.term || params.term.trim() === '') return data;
          if (data.text.toLowerCase().indexOf(params.term.toLowerCase()) !== -1) return data;
          return null;
        }
      });

      /* Patch dropdown search field on open — Select2 appends the dropdown to
         <body> with inline styles that beat CSS. Force dark bg via JS. */
      $(sel).on('select2:open', function() {
        setTimeout(function() {
          var field = document.querySelector('.select2-search--dropdown .select2-search__field');
          if (field) {
            field.style.setProperty('background',    '#161820',                          'important');
            field.style.setProperty('background-color', '#161820',                      'important');
            field.style.setProperty('color',         'rgba(255,255,255,0.90)',           'important');
            field.style.setProperty('border',        '1px solid rgba(255,255,255,0.12)','important');
            field.style.setProperty('border-radius', '6px',                              'important');
            field.style.setProperty('outline',       'none',                             'important');
          }
          /* Also patch the dropdown container background */
          var dropdown = document.querySelector('.select2-dropdown');
          if (dropdown) {
            dropdown.style.setProperty('background',    '#161820', 'important');
            dropdown.style.setProperty('background-color', '#161820', 'important');
            dropdown.style.setProperty('border',       '1px solid rgba(255,255,255,0.12)', 'important');
          }
          var searchArea = document.querySelector('.select2-search--dropdown');
          if (searchArea) {
            searchArea.style.setProperty('background', '#161820', 'important');
            searchArea.style.setProperty('background-color', '#161820', 'important');
          }
        }, 0);
      });

      /* Step 5: Manually inject placeholder text into the rendered list.
         Select2 only creates the placeholder <li> when inline search is present.
         Since we hide .select2-search--inline via CSS, Select2 never creates it.
         We add it ourselves so the box shows "Browse All Sets" etc. */
      var rendered = sel.parentNode && sel.parentNode.querySelector('.select2-selection__rendered');
      if (rendered) {
        var existing = rendered.querySelector('.select2-selection__placeholder');
        if (!existing) {
          var placeholder = document.createElement('li');
          placeholder.className = 'select2-selection__placeholder';
          placeholder.textContent = ph;
          rendered.insertBefore(placeholder, rendered.firstChild);
        } else {
          existing.textContent = ph;
        }
      }
    });

    /* Fix 3: Patch all plain inputs — explicitly skip Select2 internal search fields.
       .select2-search__field is an <input> inside .filters-toolbar__input but
       must stay transparent/borderless inside the selection container.
       Our generic input rule would style it as a dark box = the "second row" bug. */
    document.querySelectorAll('.filters-toolbar__input input').forEach(function (inp) {
      if (inp.classList.contains('select2-search__field')) {
        /* Reset: ensure Select2 search fields are invisible inside the widget */
        if (!inp.dataset.dcgS2Reset) {
          inp.dataset.dcgS2Reset = '1';
          inp.style.setProperty('background',    'transparent', 'important');
          inp.style.setProperty('border',        'none',        'important');
          inp.style.setProperty('border-radius', '0',           'important');
          inp.style.setProperty('box-shadow',    'none',        'important');
          inp.style.setProperty('padding',       '0',           'important');
          inp.style.setProperty('margin',        '0',           'important');
          inp.style.setProperty('height',        'auto',        'important');
          inp.style.setProperty('width',         'auto',        'important');
        }
        return;
      }
      if (inp.dataset.dcgPatched) return;
      inp.dataset.dcgPatched = '1';
      inp.style.setProperty('background',    '#161820',                         'important');
      inp.style.setProperty('color',         'rgba(255,255,255,0.90)',           'important');
      inp.style.setProperty('border',        '1px solid rgba(255,255,255,0.12)','important');
      inp.style.setProperty('border-radius', '8px',                              'important');
      inp.style.setProperty('padding',       '7px 10px',                         'important');
      inp.style.setProperty('height',        'auto',                             'important');
      inp.style.setProperty('margin-top',    '0',                                'important');
      inp.style.setProperty('font-size',     '12px',                             'important');
      inp.style.setProperty('font-family',   'Poppins,sans-serif',               'important');
      inp.style.setProperty('width',         '100%',                             'important');
      inp.style.setProperty('box-sizing',    'border-box',                       'important');
      inp.style.setProperty('display',       'block',                            'important');
    });

    /* Build custom set search bar for #setNames */
    buildSetSearch();
  }

  /* ── Custom set search bar ────────────────────────────────────────
     Replaces Select2 on #setNames with a type-to-filter input widget.
     The native <select> stays hidden; selections are toggled directly
     on its options and 'change' is dispatched so BinderPOS re-queries.
     Selected sets appear as removable chips below the input.
  ──────────────────────────────────────────────────────────────────── */
  function buildSetSearch() {
    /* ── Fix (13 AUG 2026): sweep orphaned dropdowns ──────────────────
       BinderPOS purges every filter label on a game change (l() in
       advancedSearch.js), destroying this widget's input while its
       dropdown lives on <body>. A detached input can never fire blur —
       the only close path — so the dropdown stayed open forever: an
       invisible same-colour (#161820) fixed overlay at z-index 9999
       covering the sidebar. Users couldn't select filters, remove
       chips, or type in the box until a full page reload.
       Runs before ALL early returns so every patchSidebarStyles cycle
       cleans up. */
    document.querySelectorAll('.dcg-set-search__dropdown').forEach(function (d) {
      if (!d._dcgControl || !d._dcgControl.isConnected) {
        if (d._dcgTeardown) d._dcgTeardown();
        if (d.parentNode) d.parentNode.removeChild(d);
      }
    });

    var sel = document.querySelector('.filters-toolbar__input select#setNames');
    if (!sel || sel.dataset.dcgSetSearch) return;
    if (!sel.options.length) return;
    sel.dataset.dcgSetSearch = '1';

    /* ── Defence 1: Block BinderPOS from re-calling .select2() on #setNames */
    if (window.jQuery && !window.jQuery.fn._dcgSetNamesGuarded) {
      window.jQuery.fn._dcgSetNamesGuarded = true;
      var _origS2fn = window.jQuery.fn.select2;
      window.jQuery.fn.select2 = function () {
        var $pass = this.filter(function () {
          return !(this.id === 'setNames' && this.dataset && this.dataset.dcgSetSearch);
        });
        if (!$pass.length) return this;
        return _origS2fn.apply($pass.length === this.length ? this : $pass, arguments);
      };
    }

    try { window.jQuery && window.jQuery(sel).select2('destroy'); } catch (e) {}
    var s2El = sel.parentNode && sel.parentNode.querySelector('.select2-container');
    if (s2El) s2El.style.setProperty('display', 'none', 'important');
    sel.style.setProperty('display', 'none', 'important');

    var wrap    = document.createElement('div');
    wrap.className = 'dcg-set-search';
    var control = document.createElement('div');
    control.className = 'dcg-set-search__control';
    var inp = document.createElement('input');
    inp.type = 'text';
    inp.className = 'dcg-set-search__input';
    inp.placeholder = 'Search sets…';
    inp.autocomplete = 'off';
    inp.setAttribute('spellcheck', 'false');
    inp.dataset.dcgPatched = '1';
    var chev = document.createElement('span');
    chev.className = 'dcg-set-search__chev';
    chev.innerHTML = '<svg viewBox="0 0 10 6" width="10" height="6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M1 1l4 4 4-4"/></svg>';
    control.appendChild(inp);
    control.appendChild(chev);
    var dropdown = document.createElement('div');
    dropdown.className = 'dcg-set-search__dropdown';
    dropdown.style.display = 'none';
    var chipsEl = document.createElement('div');
    chipsEl.className = 'dcg-set-search__chips';
    wrap.appendChild(control);
    wrap.appendChild(chipsEl);       /* dropdown lives on <body> — escapes overflow:hidden */
    sel.parentNode.appendChild(wrap);
    document.body.appendChild(dropdown);

    /* Link dropdown → control so the orphan sweep above can detect a
       dead widget, and register a teardown that detaches listeners. */
    dropdown._dcgControl = control;

    function closeDropdown() {
      dropdown.style.display = 'none';
      wrap.classList.remove('is-open');
    }

    function teardown() {
      window.removeEventListener('scroll', _aaOnScroll, true);
      window.removeEventListener('resize', _aaOnScroll);
      document.removeEventListener('mousedown', _outsideClose, true);
    }
    dropdown._dcgTeardown = teardown;

    /* Escape hatch: any click outside the widget closes the dropdown,
       even if focus/blur never fired (e.g. it was opened programmatically). */
    function _outsideClose(e) {
      if (dropdown.style.display === 'none') return;
      if (wrap.contains(e.target) || dropdown.contains(e.target)) return;
      closeDropdown();
    }
    document.addEventListener('mousedown', _outsideClose, true);

    function getOpts() {
      var arr = [];
      for (var i = 0; i < sel.options.length; i++) {
        arr.push({ value: sel.options[i].value, text: sel.options[i].text.trim(), selected: sel.options[i].selected });
      }
      return arr;
    }

    /* Position dropdown relative to control using viewport coords —
       avoids clipping from sidebar overflow:hidden containers */
    function positionDropdown() {
      /* Control removed from DOM (BinderPOS re-render) — never position
         against a detached rect (0,0). Close and self-destruct instead. */
      if (!control.isConnected) {
        closeDropdown();
        teardown();
        if (dropdown.parentNode) dropdown.parentNode.removeChild(dropdown);
        return;
      }
      var r = control.getBoundingClientRect();
      dropdown.style.top   = (r.bottom + 4) + 'px';
      dropdown.style.left  = r.left + 'px';
      dropdown.style.width = r.width + 'px';
    }

    function renderDropdown(term) {
      var all = getOpts();
      var list = term
        ? all.filter(function (o) { return o.text.toLowerCase().indexOf(term.toLowerCase()) !== -1; })
        : all;
      dropdown.innerHTML = '';
      if (!list.length) {
        var empty = document.createElement('div');
        empty.className = 'dcg-set-search__empty';
        empty.textContent = 'No sets found';
        dropdown.appendChild(empty);
      } else {
        list.forEach(function (opt) {
          var item = document.createElement('div');
          item.className = 'dcg-set-search__item' + (opt.selected ? ' is-selected' : '');
          item.textContent = opt.text;
          item.addEventListener('mousedown', function (e) { e.preventDefault(); toggleOpt(opt.value); });
          dropdown.appendChild(item);
        });
      }
      positionDropdown();
      dropdown.style.display = 'block';
    }

    function toggleOpt(value) {
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].value === value) { sel.options[i].selected = !sel.options[i].selected; break; }
      }
      sel.dispatchEvent(new Event('change'));
      renderChips();
      /* Only refresh the dropdown if it's already open. The old
         unconditional call force-OPENED it on chip-remove clicks while
         the input was unfocused — blur could then never fire, leaving
         an invisible overlay stuck over the sidebar. */
      if (dropdown.style.display !== 'none') renderDropdown(inp.value);
    }

    function renderChips() {
      chipsEl.innerHTML = '';
      getOpts().filter(function (o) { return o.selected; }).forEach(function (opt) {
        var chip = document.createElement('span');
        chip.className = 'dcg-set-search__chip';
        var lbl = document.createElement('span');
        lbl.textContent = opt.text;
        var rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'dcg-set-search__chip-rm';
        rm.setAttribute('aria-label', 'Remove ' + opt.text);
        rm.innerHTML = '<svg viewBox="0 0 9 9" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" width="8" height="8"><path d="M1 1l7 7M8 1L1 8"/></svg>';
        rm.addEventListener('click', function () { toggleOpt(opt.value); });
        chip.appendChild(lbl);
        chip.appendChild(rm);
        chipsEl.appendChild(chip);
      });
    }

    inp.addEventListener('input',  function () { renderDropdown(inp.value); });
    inp.addEventListener('focus',  function () { wrap.classList.add('is-open'); renderDropdown(inp.value); });
    inp.addEventListener('blur',   function () {
      setTimeout(closeDropdown, 160);
    });
    /* Chevron toggles the dropdown — previously it could only open
       (focus), so clicking it with the list open did nothing. */
    chev.addEventListener('mousedown', function (e) {
      e.preventDefault();
      if (dropdown.style.display !== 'none') {
        closeDropdown();
        inp.blur();
      } else {
        inp.focus();   /* focus listener opens the dropdown */
      }
    });

    /* Sync chips when clearFilter() fires — uses custom event to bypass
       jQuery stopImmediatePropagation from BinderPOS change handlers */
    sel.addEventListener('dcg:cleared', function () {
      renderChips();
      if (dropdown.style.display !== 'none') renderDropdown(inp.value);
    });

    /* Reposition dropdown when sidebar or page scrolls */
    function _aaOnScroll() { if (dropdown.style.display !== 'none') positionDropdown(); }
    window.addEventListener('scroll', _aaOnScroll, true);
    window.addEventListener('resize', _aaOnScroll);

    /* ── Defence 2: Block BinderPOS keyboard handlers from intercepting typing */
    ['keydown', 'keyup', 'keypress'].forEach(function (evtName) {
      inp.addEventListener(evtName, function (e) { e.stopPropagation(); e.stopImmediatePropagation(); }, true);
      inp.addEventListener(evtName, function (e) { e.stopPropagation(); e.stopImmediatePropagation(); });
    });

    /* ── Defence 3: Watch parent for BinderPOS re-adding a Select2 container */
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.classList && node.classList.contains('select2-container')) {
            node.style.setProperty('display', 'none', 'important');
          }
        });
      });
    }).observe(sel.parentNode, { childList: true });

    /* Watch #setNames options for game change */
    new MutationObserver(function () {
      if (!sel.options.length) {
        /* BinderPOS emptied this select in place — a new widget will be
           built when options repopulate. Tear the old one down fully so
           it can't linger as a duplicate control or stuck dropdown. */
        delete sel.dataset.dcgSetSearch;
        closeDropdown();
        teardown();
        if (dropdown.parentNode) dropdown.parentNode.removeChild(dropdown);
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        return;
      }
      renderChips();
      if (dropdown.style.display !== 'none') renderDropdown(inp.value);
    }).observe(sel, { childList: true });

    renderChips();
  }
  var pollN = 0;
  var pollId = setInterval(function () {
    if (document.querySelector('.filters-toolbar__input') || ++pollN > 100) {
      clearInterval(pollId);
      watchFilters();
      renderPills();

      /* Delay so BinderPOS's own .select2() calls complete first. */
      setTimeout(patchSidebarStyles, 600);

      /* Set default game to preferred keyword if no user pick */
      setTimeout(function () {
        var gameEl = document.querySelector('.filters-toolbar__input select#game');

        /* ── Remove excluded game options (e.g. Sealed Pokémon) ── */
        if (gameEl) {
          /* Iterate in reverse so removing an option doesn't shift indices */
          for (var r = gameEl.options.length - 1; r >= 0; r--) {
            if ((window._dcgIsExcluded || function(){return false;})(gameEl.options[r].text)) {
              gameEl.remove(r);
            }
          }
        }

        if (!window._dcgPreferGameKeyword) return;
        if (!gameEl || gameEl.dataset.dcgDefaultSet) return;
        var kw = window._dcgPreferGameKeyword.toLowerCase();
        for (var i = 0; i < gameEl.options.length; i++) {
          if (gameEl.options[i].text.toLowerCase().indexOf(kw) !== -1) {
            if (gameEl.selectedIndex !== i) {
              gameEl.selectedIndex = i;
              gameEl.dataset.dcgDefaultSet = '1';
              /* Save preference so next load respects it */
              try {
                var saved = JSON.parse(localStorage.getItem('advancedSearch') || '{}');
                saved.game = gameEl.options[i].value;
                saved._dcgUserPick = true;
                localStorage.setItem('advancedSearch', JSON.stringify(saved));
              } catch(e) {}
              gameEl.dispatchEvent(new Event('change'));
              /* #q gets wiped by this game change; enforceHeroQuery (run from
                 the product-count observer) restores the term after the render. */
            }
            break;
          }
        }
      }, 800);

      /* Re-run patch after async filter injection (Sets, Rarities, etc) */
      var filterList = document.querySelector('.filters-toolbar__input');
      if (filterList) {
        new MutationObserver(function () {
          setTimeout(patchSidebarStyles, 400);
        }).observe(filterList, { childList: true, subtree: true });
      }

      /* Fill BinderPOS input#q from URL now that it exists */
      if (urlDecoded) {
        var b = getBinderInput();
        if (b && !b.value) b.value = urlDecoded;
      }
    }
  }, 250);

  var countEl = document.querySelector('.filters-toolbar__product-count');
  if (countEl) {
    new MutationObserver(function () { watchFilters(); renderPills(); applyGameSortRestriction(); enforceHeroQuery(); })
      .observe(countEl, { childList: true, subtree: true, characterData: true });
  }

  /* ── Sort restriction for BinderPOS-limited games ──────────────────
     Digimon and One Piece have a BinderPOS server bug where price sort
     ignores instockOnly and set/rarity filters are ignored server-side.
     Hooked into the product count MutationObserver so it fires after
     every BinderPOS render cycle — guaranteed to run after game changes.
  ────────────────────────────────────────────────────────────────── */
  var SORT_RESTRICTED_GAMES = ['digimon', 'one piece', 'one_piece'];
  var _sortOptionsCache     = null;

  function isRestrictedGame(gameText) {
    var t = (gameText || '').toLowerCase();
    return SORT_RESTRICTED_GAMES.some(function (g) { return t.indexOf(g) !== -1; });
  }

  function applyGameSortRestriction() {
    var sortEl  = document.getElementById('SortBy');
    var gameEl  = document.querySelector('.filters-toolbar__input select#game');
    if (!sortEl || !gameEl) return;

    /* Build cache from current options before any removal */
    if (!_sortOptionsCache || _sortOptionsCache.length < sortEl.options.length) {
      var all = Array.from(sortEl.options).map(function (o) {
        return { value: o.value, text: o.text };
      });
      if (all.length > 1) _sortOptionsCache = all;
    }

    var opt        = gameEl.options[gameEl.selectedIndex];
    var gameText   = opt ? opt.text : '';
    var restricted = isRestrictedGame(gameText);
    var currentVal = sortEl.value;

    if (restricted) {
      /* Remove all options except Name: A→Z */
      for (var i = sortEl.options.length - 1; i >= 0; i--) {
        if (sortEl.options[i].value !== 'title-ascending') sortEl.remove(i);
      }
      if (sortEl.value !== 'title-ascending') {
        sortEl.value = 'title-ascending';
        sortEl.dispatchEvent(new Event('change'));
      }
    } else {
      /* Restore full option list if it was reduced */
      if (_sortOptionsCache && sortEl.options.length < _sortOptionsCache.length) {
        while (sortEl.options.length > 0) sortEl.remove(0);
        _sortOptionsCache.forEach(function (o) {
          var opt  = document.createElement('option');
          opt.value = o.value;
          opt.text  = o.text;
          sortEl.appendChild(opt);
        });
        /* Restore previously selected sort */
        if (currentVal) sortEl.value = currentVal;
      }
    }
  }

  /* Run once on load after BinderPOS injects the game select */
  (function initSortRestriction() {
    var gameEl = document.querySelector('.filters-toolbar__input select#game');
    if (!gameEl) { setTimeout(initSortRestriction, 300); return; }
    applyGameSortRestriction();
  })();

})();


/* ── §6: BinderPOS card reshaper + Shopify enrichment ────────────── */
(function () {
  'use strict';

  /* ── Money helper ─────────────────────────────────────────────── */
  function money(cents) {
    try { return Shopify.formatMoney(cents, window.theme.moneyWithCurrencyFormat); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  /* ── Phase 1: reshape BinderPOS card into exact dcg-product-card.liquid DOM ─
     buildCardUI() reads specific selectors — we must match them exactly:
       titleEl  = .dcg-product-card__title a  → for card name + href
       priceWrap = .product-price__price       → needs .money span(s) inside
       actionsEl = .add_to_cart_main           → the ATC form wrapper
       atcBtn    = .nm-addToCart               → must be <button>, not <a>
       hiddenVar = input[name="prduct-variant"] → type="hidden"
       hiddenQty = input[name="product-quantity"] → type="hidden"
     buildCardUI then wipes content and replaces with its own rows.
  ──────────────────────────────────────────────────────────────────── */
  function reshapeCard(wrapper) {
    if (wrapper.dataset.dcgReshaped) return;
    wrapper.dataset.dcgReshaped = '1';

    var card = wrapper.querySelector('.grid-view-item');
    if (!card) return;

    /* ── Extract data from BinderPOS-generated card ──────────────── */
    var imgEl     = card.querySelector('.grid-view-item__image');
    var imgSrc    = imgEl ? imgEl.src : '';
    var titleEl   = card.querySelector('.h4.grid-view-item__title');
    var titleText = titleEl ? titleEl.textContent.trim() : '';
    var linkEl    = card.querySelector('.product-detail a, .grid-view-item__image-container a');
    var href      = linkEl ? linkEl.getAttribute('href') : '#';
    var handle    = href.replace('/products/', '').split('?')[0].split('#')[0];
    var priceEl   = card.querySelector('.product-price__price');
    var priceText = priceEl ? priceEl.textContent.trim() : '';
    var selectEl  = card.querySelector('select.collection__select');
    var isSoldOut = !!(card.querySelector('.outstock-overlay'));

    /* Fix 1: BinderPOS server bug — availability filter not enforced when
       sorting by price for certain games (One Piece, Digimon, Lorcana,
       Star Wars, Grand Archive). BinderPOS marks fully sold-out cards with
       .outstock-overlay in its own DOM before our reshaper runs.
       If In Stock Only is active, hide this card immediately. */
    if (isSoldOut) {
      var _avEl = document.querySelector('.filters-toolbar__input select#availabilty');
      if (_avEl && String(_avEl.value) === 'true') {
        wrapper.style.setProperty('display', 'none', 'important');
        return;
      }
    }

    var variantId = selectEl ? selectEl.value : '';
    var titleSafe = titleText.replace(/"/g, '&quot;');

    /* Build variant options from BinderPOS select */
    var optionsHtml = '';
    if (selectEl) {
      selectEl.querySelectorAll('option').forEach(function (opt) {
        optionsHtml += '<option value="' + opt.value + '"' +
          (opt.value === variantId ? ' selected' : '') + '>' + opt.text + '</option>';
      });
    }

    /* ── Stamp wrapper attributes ──────────────────────────────────── */
    wrapper.className            = 'grid__item dcg-product-card-item';
    wrapper.dataset.productId    = variantId;   /* real ID stamped in Phase 2 */
    wrapper.dataset.productHandle = handle;

    /* ── Rebuild card to match dcg-product-card.liquid exactly ──────
       CSS hides .dcg-product-card__title and .product-price__price —
       they exist only for buildCardUI to read, then it replaces them.
    ─────────────────────────────────────────────────────────────────── */
    card.className = 'grid-view-item dcg-product-card' + (isSoldOut ? ' sold-out' : '');
    card.innerHTML =
      /* ── Image stage ── */
      '<div class="grid-view-item__image-container dcg-product-card__media dcg-media--single">' +
        '<a href="' + href + '" class="grid-view-item__link dcg-product-card__image-link">' +
          '<div class="reveal">' +
            (imgSrc ? '<img class="grid-view-item__image dcg-product-card__image" src="' + imgSrc + '" alt="' + titleSafe + '" loading="lazy">' : '') +
          '</div>' +
        '</a>' +
        '<div class="sale-flag"></div>' +
        '<div class="tag-container" data-tag-container></div>' +
      '</div>' +

      /* ── Card body ── */
      '<div class="grid-view-item__meta dcg-product-card__content">' +

        /* Variant select — CSS hides it, buildCardUI ignores it and creates its own */
        '<div class="dcg-product-card__variants product-form__controls-group">' +
          '<select id="ProductSelect-Dropdown-' + variantId + '" ' +
                  'class="single-option-selector product-form__input" data-product-select>' +
            optionsHtml +
          '</select>' +
        '</div>' +

        /* Title — CSS hides it (.dcg-product-card__title { display:none })
           buildCardUI reads titleEl.textContent and titleEl.getAttribute("href") */
        '<div class="h4 grid-view-item__title product-card__title dcg-product-card__title">' +
          '<a href="' + href + '">' + titleText + '</a>' +
        '</div>' +

        /* Price — CSS hides it (.product-price__price { display:none })
           buildCardUI reads .money spans for fallbackPrice */
        '<div class="product-price__price dcg-product-card__price">' +
          '<span class="money">' + priceText + '</span>' +
        '</div>' +

        /* ATC form — actionsEl + atcBtn references buildCardUI saves before wiping */
        '<div class="grid-cart dcg-product-card__actions add_to_cart_main">' +
          '<form class="product-form" method="post" action="/cart/add">' +
            '<input type="hidden" name="prduct-variant" value="' + variantId + '">' +
            '<input type="hidden" name="product-quantity" value="1">' +
            '<div class="nm-cartmain">' +
              '<button type="button" ' +
                      'class="btn add-to-cart nm-addToCart addToCart' + (isSoldOut ? ' disabled' : ' enable') + '"' +
                      (isSoldOut ? ' disabled' : '') + '>' +
                (isSoldOut ? 'Sold Out' : 'Add to Cart') +
              '</button>' +
            '</div>' +
          '</form>' +
        '</div>' +

      '</div>';

    /* Phase 2: fetch Shopify product data */
    enrichCard(wrapper, handle);
  }

  /* ── Phase 2: enrich with Shopify product data ────────────────── */
  function enrichCard(wrapper, handle) {
    if (!handle) return;

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        /* Stamp real Shopify data attributes for dcg-product-card.js */
        wrapper.dataset.productId     = product.id;
        wrapper.dataset.productHandle = product.handle;
        wrapper.dataset.productTags   = JSON.stringify(product.tags || []);

        /* ── Retail Only badge ─────────────────────────────────────── */
        var isRetail = (product.tags || []).some(function(t) {
          return t.toLowerCase() === 'retail';
        });
        var cardMedia = wrapper.querySelector('.dcg-product-card__media, .grid-view-item__image-container');
        if (isRetail && cardMedia && !cardMedia.querySelector('.dcg-retail-badge')) {
          var rb = document.createElement('div');
          rb.className = 'dcg-retail-badge';
          rb.textContent = 'Retail Only';
          cardMedia.appendChild(rb);
        }

        var variantData = (product.variants || []).map(function (v) {
          return {
            id:                   v.id,
            title:                v.title,
            available:            v.available,
            price:                v.price,
            compare_at_price:     v.compare_at_price,
            inventory_quantity:   v.inventory_quantity,
            inventory_policy:     v.inventory_policy,
            inventory_management: v.inventory_management,
            featured_image:       v.featured_image
          };
        });
        wrapper.dataset.productVariants = JSON.stringify(variantData);

        /* Build inventory map for effectiveStockForVariant() */
        var invMap = {};
        (product.variants || []).forEach(function (v) {
          invMap[v.id] = {
            qty:        v.inventory_quantity,
            policy:     v.inventory_policy,
            management: v.inventory_management
          };
        });

        /* Merge BinderPOS quantities over Shopify's data.
           Shopify never receives inventory_quantity from BinderPOS (only
           available:true/false syncs). Our fetch interceptor captured the
           real counts from the products/forStore response. Apply them now
           so effectiveStockForVariant() caps the qty widget correctly. */
        var _dcgQtyMap = window._dcgBinderQtyMap || {};
        Object.keys(invMap).forEach(function (vid) {
          var binderQty = _dcgQtyMap[String(vid)];
          if (typeof binderQty === 'number' && binderQty > 0) {
            invMap[vid].qty    = binderQty;
            invMap[vid].policy = 'deny';
          }
        });

        wrapper.dataset.variantInventory = JSON.stringify(invMap);

        /* Reset init flag so dcgInitProductCards runs a full build */
        delete wrapper.dataset.dcgCardInit;

        /* dcg-product-card.js is deferred — poll until it defines dcgInitProductCards.
           Capped at 100 tries (~5s) so a missing/renamed dcgInitProductCards can't
           spin a 50ms timer forever, per card. */
        var callInitTries = 0;
        function callInit() {
          if (window.dcgInitProductCards) {
            window.dcgInitProductCards(wrapper.parentElement || document);
          } else if (callInitTries++ < 100) {
            setTimeout(callInit, 50);
          }
        }
        callInit();
      })
      .catch(function () {
        /* Fetch failed — fall back to BinderPOS variant data */
        var select = wrapper.querySelector('select.dcg-card-cond-select, select.collection__select');
        if (!select || !select.options.length) return;

        var fallbackVariants = [];
        for (var i = 0; i < select.options.length; i++) {
          var opt = select.options[i];
          if (opt.value) {
            fallbackVariants.push({
              id:                   parseInt(opt.value, 10),
              title:                opt.text.replace(/\s*\(\d+\)\s*$/, '').trim(),
              available:            true,
              price:                0,
              compare_at_price:     null,
              inventory_quantity:   99,
              inventory_policy:     'continue',
              inventory_management: ''
            });
          }
        }
        if (fallbackVariants.length) {
          wrapper.dataset.productVariants = JSON.stringify(fallbackVariants);
          wrapper.dataset.variantInventory = '{}';
          delete wrapper.dataset.dcgCardInit;
          /* Capped at 100 tries (~5s) — see callInit above. */
          var callInitFallbackTries = 0;
          function callInitFallback() {
            if (window.dcgInitProductCards) {
              window.dcgInitProductCards(wrapper.parentElement || document);
            } else if (callInitFallbackTries++ < 100) {
              setTimeout(callInitFallback, 50);
            }
          }
          callInitFallback();
        }
      });
  }

  /* ── Auto-advance: collect in-stock cards across pages ────────────
     When In Stock Only is active + price sort returns sold-out pages
     (BinderPOS server bug on One Piece, Digimon, Lorcana, etc.):

     Phase — collecting:
       Silently click next page each time all cards are hidden.
       Stash any in-stock cards found along the way (node moves,
       not clones — all event listeners are preserved).
     Phase — display:
       Once stash + current page reaches 18 cards (or no more pages),
       clear the grid, inject all collected cards, reset to "Page 1".

     Cap: _aaMax page skips to prevent runaway loops. */
  var _aaTimer  = null;
  var _aaCount  = 0;
  var _aaMax    = 20;
  var _aaPhase  = 'idle';   /* 'idle' | 'collecting' */
  var _aaStash  = null;     /* hidden div — holds collected in-stock cards */

  function getOrCreateStash() {
    if (!_aaStash) {
      _aaStash = document.createElement('div');
      _aaStash.id = 'dcg-aa-stash';
      _aaStash.setAttribute('aria-hidden', 'true');
      _aaStash.style.cssText = 'display:none!important';
      document.body.appendChild(_aaStash);
    }
    return _aaStash;
  }

  function showAASpinner() {
    if (document.querySelector('.dcg-aa-spinner')) return;
    var col = document.getElementById('Collection');
    var cnt = document.querySelector('.dcg-as-count');
    if (col) col.style.setProperty('opacity', '0', 'important');
    if (cnt) cnt.style.setProperty('opacity', '0', 'important');
    var wrap = document.querySelector('.dcg-as-wrap');
    if (wrap && col) {
      var s = document.createElement('div');
      s.className = 'dcg-aa-spinner';
      s.innerHTML =
        '<div class="dcg-aa-ripple"><div></div><div></div></div>' +
        '<p class="dcg-aa-msg">Finding in‑stock cards…</p>';
      wrap.insertBefore(s, col);
    }
  }

  function hideAASpinner() {
    var s   = document.querySelector('.dcg-aa-spinner');
    var col = document.getElementById('Collection');
    var cnt = document.querySelector('.dcg-as-count');
    if (s && s.parentNode) s.parentNode.removeChild(s);
    if (col) col.style.removeProperty('opacity');
    if (cnt) cnt.style.removeProperty('opacity');
  }

  /* Move visible in-stock cards from grid into stash (preserves listeners) */
  function stashVisibleCards(grid) {
    var stash = getOrCreateStash();
    grid.querySelectorAll('.grid__item[data-dcg-reshaped]').forEach(function (c) {
      if (c.style.display !== 'none') stash.appendChild(c);
    });
  }

  /* Inject all stash + current-page visible cards into grid, reset Page 1 */
  function finishCollection(grid) {
    _aaPhase = 'idle';
    _aaCount = 0;

    var stash = getOrCreateStash();
    var stashCards     = Array.from(stash.querySelectorAll('.grid__item'));
    var currentVisible = Array.from(
      grid.querySelectorAll('.grid__item[data-dcg-reshaped]')
    ).filter(function (c) { return c.style.display !== 'none'; });

    /* Remove every .grid__item currently in the grid */
    Array.from(grid.querySelectorAll('.grid__item')).forEach(function (c) {
      grid.removeChild(c);
    });

    /* Inject stash (earlier pages) then current-page in-stock cards */
    stashCards.forEach(function (c) {
      c.style.removeProperty('display');
      grid.appendChild(c);
    });
    currentVisible.forEach(function (c) {
      c.style.removeProperty('display');
      grid.appendChild(c);
    });

    /* Clear stash for next run */
    stash.innerHTML = '';

    /* Reset pagination display to Page 1 */
    var textEl = document.querySelector('.pagination__text');
    if (textEl) textEl.textContent = 'Page 1';
    var prevSpan = document.querySelector('.dcg-as-pag .pag_previous');
    if (prevSpan) {
      prevSpan.innerHTML =
        '<div class="btn--disabled">' +
        '<i class="material-icons">navigate_before</i> Previous</div>';
    }

    hideAASpinner();
  }

  function checkAutoAdvance() {
    clearTimeout(_aaTimer);
    _aaTimer = setTimeout(function () {

      var avEl = document.querySelector('.filters-toolbar__input select#availabilty');
      if (!avEl || String(avEl.value) !== 'true') {
        _aaCount = 0; _aaPhase = 'idle'; hideAASpinner(); return;
      }

      var grid = document.querySelector('.dcg-as-grid.products-display');
      if (!grid) return;

      var allCards = grid.querySelectorAll('.grid__item[data-dcg-reshaped]');
      if (!allCards.length) return;

      var visibleCards = Array.from(allCards).filter(function (c) {
        return c.style.display !== 'none';
      });

      var stashCount = _aaStash
        ? _aaStash.querySelectorAll('.grid__item').length
        : 0;

      /* ── Case 1: All cards hidden — advance to next page ────────── */
      if (visibleCards.length === 0) {
        if (_aaPhase === 'idle') { _aaPhase = 'collecting'; showAASpinner(); }
        var nextBtn1 = document.querySelector('.dcg-as-pag .pag_next a');
        if (!nextBtn1 || _aaCount >= _aaMax) { finishCollection(grid); return; }
        _aaCount++;
        nextBtn1.click();
        return;
      }

      /* ── Case 2: Have visible cards + actively collecting ───────── */
      if (_aaPhase === 'collecting') {
        var total = stashCount + visibleCards.length;
        if (total >= 18) { finishCollection(grid); return; }
        var nextBtn2 = document.querySelector('.dcg-as-pag .pag_next a');
        if (!nextBtn2 || _aaCount >= _aaMax) { finishCollection(grid); return; }
        stashVisibleCards(grid);
        _aaCount++;
        nextBtn2.click();
        return;
      }

      /* ── Case 3: Normal load — found cards, no collection needed ── */
      _aaCount = 0; _aaPhase = 'idle'; hideAASpinner();

    }, 200);
  }

  /* ── Watch grid for new BinderPOS cards ───────────────────────── */
  function observeGrid() {
    var grid = document.querySelector('.dcg-as-grid.products-display');
    if (!grid) return;
    if (!grid.classList.contains('dcg-collection')) grid.classList.add('dcg-collection');

    /* Reshape cards already present */
    grid.querySelectorAll('.grid__item').forEach(reshapeCard);

    /* Watch for BinderPOS appending new cards */
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) reshapeCard(node);
        });
      });
      checkAutoAdvance();
    }).observe(grid, { childList: true });
  }

  /* Boot after DOM is ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeGrid);
  } else {
    observeGrid();
  }

  /* Also trigger when BinderPOS updates the product count */
  var countEl = document.querySelector('.filters-toolbar__product-count');
  if (countEl) {
    new MutationObserver(function () {
      var grid = document.querySelector('.dcg-as-grid.products-display');
      if (!grid) return;
      if (!grid.classList.contains('dcg-collection')) grid.classList.add('dcg-collection');
      grid.querySelectorAll('.grid__item:not([data-dcg-reshaped])').forEach(reshapeCard);
    }).observe(countEl, { childList: true, subtree: true, characterData: true });
  }

})();


/* ── §7: Mobile filter drawer ────────────────────────────────────── */
(function () {
  var OPEN = 'dcg-filter-open';
  var btn      = document.getElementById('dcg-as-filter-btn');
  var backdrop = document.getElementById('dcg-filter-backdrop');
  var countEl  = document.getElementById('dcg-as-filter-count');
  var pillsEl  = document.getElementById('dcg-as-pills');

  if (!btn) return;

  /* iOS-proof scroll lock (13 AUG 2026).
     html{overflow:hidden} alone is ignored by iOS Safari, so with the drawer
     open every touch drag scrolled/rubber-banded the PAGE behind the drawer —
     the filter panel visually "snapped back to the top" and users could never
     reach the lower filters (Sets) on mobile. Fixing the body in place is the
     reliable cross-browser lock; the saved scroll offset is restored on close. */
  var _savedScrollY = 0;

  function openDrawer() {
    document.body.classList.add(OPEN);
    btn.setAttribute('aria-expanded', 'true');
    _savedScrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = (-_savedScrollY) + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function closeDrawer() {
    document.body.classList.remove(OPEN);
    btn.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, _savedScrollY);
  }

  btn.addEventListener('click', openDrawer);
  if (backdrop) backdrop.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains(OPEN)) closeDrawer();
  });

  /* Close button injected into the top of the sidebar once ready */
  function injectCloseBtn() {
    var sidebar = document.querySelector('.sidebar_content .dcg-sidebar');
    if (!sidebar || sidebar.querySelector('.dcg-sidebar-close-btn')) return;
    var btn_el = document.createElement('button');
    btn_el.type = 'button';
    btn_el.className = 'dcg-sidebar-close-btn';
    btn_el.setAttribute('aria-label', 'Close filters');
    btn_el.innerHTML =
      '<span style="font-size:12px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:rgba(255,255,255,.5);">Filters</span>' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    btn_el.addEventListener('click', closeDrawer);
    sidebar.insertBefore(btn_el, sidebar.firstChild);
  }

  /* Run after BinderPOS injects — mirrors section poll timing */
  var pollC = 0;
  var closePoll = setInterval(function () {
    if (document.querySelector('.filters-toolbar__input') || ++pollC > 120) {
      clearInterval(closePoll);
      injectCloseBtn();
    }
  }, 250);

  /* Active filter count badge */
  function updateCount() {
    if (!countEl || !pillsEl) return;
    var n = pillsEl.querySelectorAll('.dcg-as-pill').length;
    countEl.textContent = n;
    countEl.hidden = n === 0;
  }
  if (pillsEl) {
    new MutationObserver(updateCount).observe(pillsEl, { childList: true, subtree: true });
    updateCount();
  }
})();
